import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';

const dialogRootNode = document.createElement('div');

const body = document.querySelector('body');
body?.appendChild(dialogRootNode);

export interface BaseDialogProps {
  giveAnswer: (answer: unknown) => void;
}

export const dialog = (DialogContent: React.ComponentType<BaseDialogProps>) =>
  new Promise(resolve => {
    const giveAnswer = (answer: unknown) => {
      unmountComponentAtNode(dialogRootNode);
      resolve(answer);
    };

    render(<DialogContent giveAnswer={giveAnswer} />, dialogRootNode);
  });
